import { useRouter } from 'next/router'

import { Button } from '@wartek-id/button-v1'
import { Text } from '@wartek-id/text-v1'

type ActionCardProps = {
  icon: string | null
  title: string
  buttonLabel: string
  buttonColor: 'black' | 'white'
  disabled?: boolean
  href?: string
  onClick?: () => void
}

type CardPelaksanaan2026Props = {
  cards: ActionCardProps[]
}
const CardPelaksanaan2026 = ({ cards }: CardPelaksanaan2026Props) => {
  const router = useRouter()

  return (
    <>
      <div className="p-6">
        <div className="space-y-4">
          {cards.map((item) => (
            <div
              key={item.title}
              className="flex items-center justify-between p-4 border border-gray-30 rounded-lg"
            >
              <div className="flex items-center gap-4">
                {item.icon && (
                  <img src={item.icon} alt="" width={64} height={64} />
                )}
                <Text variant="heading-sm">{item.title}</Text>
              </div>
              <Button
                color={item.buttonColor}
                fullWidth
                className="max-w-44"
                disabled={item.disabled}
                onClick={() => {
                  if (item.onClick) {
                    item.onClick()
                  }

                  if (item.href) {
                    router.push(item.href)
                  }
                }}
              >
                {item.buttonLabel}
              </Button>
            </div>
          ))}
        </div>
      </div>
    </>
  )
}

export default CardPelaksanaan2026
